import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ADD_RIGHTS_QUERY_KEY } from "../constants";
import { AddRightsService } from "../services/addRights.service";

export function useGetAddRightsByBriefInfluencerId(briefInfluencerId: string) {
  const { data, isLoading, error, isError, refetch } = useQuery({
    queryKey: [ADD_RIGHTS_QUERY_KEY, "briefInfluencerId", briefInfluencerId],
    queryFn: () =>
      AddRightsService.getAddRightsByBriefInfluencerId(briefInfluencerId),
    enabled: !!briefInfluencerId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    addRights: data?.data,
    isLoading,
    error,
    refetchAdRights: refetch
  };
}
